import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { IconLink } from '@/components/icon/tabler/IconLink';
import { useTranslate } from '@/state/i18n';
import { radiusTokens } from '@/theme/themePrimitives';

/** No link yet: the Bodyprint team creates them; the partner only shares and follows them. */
const AcquisitionEmptyState = () => {
  const t = useTranslate('domain.acquisition.components.AcquisitionEmptyState');

  return (
    <Paper variant="outlined" sx={{ borderRadius: radiusTokens.xxl }}>
      <Stack alignItems="center" textAlign="center" gap={1.5} sx={{ py: 8, px: 2 }}>
        <IconLink color="primary" sx={{ fontSize: 32 }} />
        <Typography variant="subtitle1" fontWeight={600}>
          {t('title')}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 480 }}>
          {t('hint')}
        </Typography>
      </Stack>
    </Paper>
  );
};

export default AcquisitionEmptyState;
